exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pc_none[data-v-f5dc8a9c] {\n    display: none;\n}\n.sp_none[data-v-f5dc8a9c] {\n    display: table-row;\n}\n.dialog-wrap[data-v-f5dc8a9c] {\n    overflow-x: hidden;\n}\n@media screen and (max-width: 896px) {\n.pc_none[data-v-f5dc8a9c] {\n        display: table-row;\n}\n.sp_none[data-v-f5dc8a9c] {\n        display: none;\n}\n.tableheader-spmr[data-v-f5dc8a9c] {\n        margin-right: 7px;\n}\n}\n", ""]);

// exports
